<template>
    <div class="container">
        <ul class="progressbar" v-if="list">
          <li v-for="(item, index) in list" :key="index" :id="item.id" :value="item.key" :style="setWidth"
          :class="isStatus ? index < statusIndex ? 'previous' : index > statusIndex ? 'next' : currentStatus === 'Closed' ? 'closed' : 'active' : 'next'"
          >{{item.name}}</li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
      list: {
        type: Array,
        required: true
      },
      currentStatus: {
        type: String,
        required: true
      },      
    },
  data() {
    return {
      length: this.list.length
    };
  },
  watch: {
    currentStatus : {        
      handler: function(newVal, oldVal) {        
        this.$forceUpdate();
      },
    }
  },
  computed: {
    statusIndex() {
      if(!this.currentStatus || -1 >= this.currentStatus ) return -1
      return this.list.findIndex(
          item => item.id === this.currentStatus
      );
    },
    isStatus() {
      console.log('this.statusIndex ',this.statusIndex)
        return -1 != this.statusIndex ? true : false;
    },
    setWidth() {
      let width = 100/this.length;         
      return { width: `${width}%` };
    },
  }
};
</script>
<style scoped>
.container{
    width: 100%;
    position: absolute;
    z-index: 1;
    margin-top: 45px;
    padding-left: 0px;
}
.progressbar{
  width: 100%;
  counter-reset: step;
  font-size: 12px;
  margin-top: 25px;
}
.progressbar li{
  float: left;
  position: relative;
  text-align: center;
}
.progressbar li:before{
  content:attr(value);
  width: 40px;
  height: 40px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 36px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}
.progressbar li:after{
  content: '';
  position: absolute;
  width:100%;
  height: 2px;
  background: #979797;
  top: 19px;
  left: 0%;
  z-index: -1;
}

.progressbar li.active:before{
 background: #064163;
 color: white
}

.progressbar li.closed:before{
 background: red;
 color: white
}

.progressbar li.previous:before{
 background: #34aff5;
 color: white
}

.progressbar li.next:before{
 background: #c4c4c4;
 color: white
}

ul {
  list-style-type: none;
  padding: 0;
}
</style>
